import {
  Container
} from "./chunk-GQ3RJ3UX.mjs";
import {
  InlineError
} from "./chunk-XU42F452.mjs";

// src/VerticallyAlignedBlogCardsWithShapedImage.tsx
import { useState } from "react";
import { useTheme } from "@mui/material/styles/index.js";
import Box from "@mui/material/Box/index.js";
import Typography from "@mui/material/Typography/index.js";
import Grid from "@mui/material/Grid/index.js";
import Card from "@mui/material/Card/index.js";
import CardContent from "@mui/material/CardContent/index.js";
import { useTranslation } from "react-i18next";
import DownloadIcon from "@mui/icons-material/esm/Download.js";
import TextField from "@mui/material/TextField/index.js";
import InputAdornment from "@mui/material/InputAdornment/index.js";
import SearchIcon from "@mui/icons-material/esm/Search.js";
import { jsx, jsxs } from "react/jsx-runtime";
var VerticallyAlignedBlogCardsWithShapedImage = ({
  certificateData,
  error,
  onRetry,
  filterCategory = ""
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [searchQuery, setSearchQuery] = useState("");
  const sortedCertificateData = [...certificateData].sort((a, b) => {
    if (a.category === "" && b.category !== "") {
      return -1;
    }
    if (a.category !== "" && b.category === "") {
      return 1;
    }
    return a.category.localeCompare(b.category);
  });
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  const filteredCertificateData = sortedCertificateData.filter((group) => {
    const matchesSearch = searchQuery ? group.category.toLowerCase().includes(searchQuery.toLowerCase()) || group.files.some(
      (item) => (item.name ?? "").toLowerCase().includes(searchQuery.toLowerCase())
    ) : true;
    const matchesFilterCategory = filterCategory ? group.category.toLowerCase().includes(filterCategory.toLowerCase()) : true;
    return matchesSearch && matchesFilterCategory;
  });
  return /* @__PURE__ */ jsxs(Container, { children: [
    /* @__PURE__ */ jsx(
      Box,
      {
        display: "flex",
        justifyContent: "space-between",
        alignItems: { xs: "flex-start", sm: "center" },
        flexDirection: { xs: "column", sm: "row" },
        marginBottom: 4,
        children: /* @__PURE__ */ jsxs(Box, { children: [
          /* @__PURE__ */ jsx(Typography, { fontWeight: 700, variant: "h4", gutterBottom: true, children: t("certificates.title") }),
          /* @__PURE__ */ jsx(Typography, { color: "text.secondary", variant: "h6", children: t("certificates.subText") })
        ] })
      }
    ),
    /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(
      TextField,
      {
        variant: "outlined",
        fullWidth: true,
        value: searchQuery,
        onChange: handleSearchChange,
        placeholder: t("certificates.filterByProductCategory"),
        InputProps: {
          startAdornment: /* @__PURE__ */ jsx(InputAdornment, { position: "start", children: /* @__PURE__ */ jsx(SearchIcon, {}) })
        },
        sx: {
          backgroundColor: theme.palette.background.paper,
          borderRadius: "8px",
          boxShadow: `0px 4px 12px rgba(0, 0, 0, 0.1)`,
          marginBottom: 4
        }
      }
    ) }),
    error && certificateData.length === 0 && /* @__PURE__ */ jsx(InlineError, { onRetry }),
    filteredCertificateData.map((group, groupIndex) => /* @__PURE__ */ jsxs(Box, { marginBottom: 4, children: [
      /* @__PURE__ */ jsx(Typography, { variant: "h5", gutterBottom: true, children: group.category }),
      /* @__PURE__ */ jsx(Grid, { container: true, spacing: 4, children: group.files.map((item, i) => /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, sm: 6, md: 4, children: /* @__PURE__ */ jsx(
        Card,
        {
          sx: {
            display: "flex",
            flexDirection: "column",
            height: "100%",
            border: `1px solid ${theme.palette.divider}`,
            boxShadow: "none",
            position: "relative"
          },
          children: /* @__PURE__ */ jsx(
            Box,
            {
              component: "a",
              href: item.link,
              target: "_blank",
              rel: "noopener noreferrer",
              display: "flex",
              flexDirection: "column",
              width: 1,
              height: 1,
              sx: {
                textDecoration: "none",
                transition: "all .2s ease-in-out",
                "&:hover": {
                  transform: `translateY(-${theme.spacing(1 / 2)})`
                }
              },
              children: /* @__PURE__ */ jsxs(CardContent, { children: [
                /* @__PURE__ */ jsxs(Box, { display: "flex", justifyContent: "space-between", children: [
                  /* @__PURE__ */ jsxs(Box, { children: [
                    /* @__PURE__ */ jsx(
                      Typography,
                      {
                        variant: "h6",
                        color: "text.primary",
                        fontWeight: "bold",
                        gutterBottom: true,
                        children: item.name
                      }
                    ),
                    /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "text.secondary", children: "Additional Information" })
                  ] }),
                  /* @__PURE__ */ jsx(
                    DownloadIcon,
                    {
                      sx: {
                        color: theme.palette.primary.main,
                        position: "absolute",
                        top: theme.spacing(1),
                        right: theme.spacing(1)
                      },
                      children: /* @__PURE__ */ jsx(
                        "img",
                        {
                          src: "/assets/download.svg",
                          alt: "Download",
                          style: { width: 20, height: 20 }
                        }
                      )
                    }
                  )
                ] }),
                /* @__PURE__ */ jsx(
                  Box,
                  {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-end",
                    marginTop: 2,
                    children: /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "text.secondary", children: "PDF" })
                  }
                )
              ] })
            }
          )
        }
      ) }, i)) })
    ] }, groupIndex))
  ] });
};
export {
  VerticallyAlignedBlogCardsWithShapedImage
};
